import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import { useAuth } from "../auth/AuthContext";

export const Upgrade = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "var(--bg-primary)" }}>
      <div className="max-w-md text-center space-y-6 border border-grid p-10" data-testid="upgrade-page">
        <Lock size={32} className="mx-auto" style={{ color: "var(--bull)" }} />
        <h1 className="font-heading text-2xl">Auto Trading subscription required</h1>
        <p className="text-xs text-muted-2 leading-relaxed">
          Your current plan is <strong>{user?.subscription === "TIPS" ? "Tips" : "None"}</strong>.
          Auto Picks (S5/S6/S8) and algorithmic execution require the
          <strong> Auto Trading</strong> subscription. During beta, subscriptions are
          admin-assigned — drop us a note and we'll upgrade you.
        </p>
        <div className="flex gap-3 justify-center">
          <button
            onClick={() => navigate("/dashboard")}
            data-testid="upgrade-back"
            className="px-4 py-2 border border-grid text-[11px] uppercase tracking-[0.2em] font-mono-data inline-flex items-center gap-2"
          >
            <ArrowLeft size={12} /> Back
          </button>
        </div>
      </div>
    </div>
  );
};
